module.exports = __webpack_public_path__ + "img/potencia_a_gray.e1db0b73.svg";